import { Component, OnInit } from '@angular/core';
import { Location } from "@angular/common";
import { Router } from "@angular/router";
import { Subject } from "rxjs";
import { CommonService } from '../Services/common.service';
import { AccountService } from '../Services/account.service';
import { CardServiceService } from '../Services/card-service.service';
import { AuthService } from '../Services/auth.service';
import { CookieService } from '../Services/cookie';
import { TopupServiceService } from '../Services/topup-service.service';

@Component({
  selector: "app-card-request-letters",
  templateUrl: "./card-request-letters.component.html",
  standalone:false,
  styleUrls: ["./card-request-letters.component.scss"],
})
export class CardRequestLettersComponent implements OnInit {
  modalObservable: Subject<void> = new Subject<void>();
  Acceptlimit: any;

  RelationshipList: any;
  selectedRelationship: string = "";
  LetterList: any;
  selectedLetter: string = "";
  LettersList;
  PaymentRequired: boolean = false;
  selectedCardDetail: any;
  PaymentDetail: any;
  TotalAmount: number;
  transactionRefId: any;
  RLServiceid: any;


  constructor(private _router: Router, private location: Location, private commonP:CommonService,  private cookieService: CookieService, 
      public cardService: CardServiceService,     public topupservice: TopupServiceService,private auth: AuthService,  ) {}

  async ngOnInit(): Promise<any> {

    let SC =await this.cookieService.get("selectedCardDetail", true);

    if (SC) {

      this.selectedCardDetail = JSON.parse(SC);

    }

   this.GetLettersList();

    this.RelationshipList = [
      {
        iconClass: "",
        displayValue: "Parent",
      },
      {
        iconClass: "",
        displayValue: "Siblings",
      },
      {
        iconClass: "",
        displayValue: "Spouse",
      },
      {
        iconClass: "",
        displayValue: "Children",
      },
    ];
    // this.LetterList = [
    //   {
    //     iconClass: "",
    //     displayValue: "Outstanding Balance Letter",
    //   },
    //   {
    //     iconClass: "",
    //     displayValue: "Statement of Account",
    //   },
    //   {
    //     iconClass: "",
    //     displayValue: "Cancellation Letter",
    //   },
    // ];
  }

  back() {
    this.location.back();
  }

  onRelationshipChange(event) {
    this.selectedRelationship = event.displayValue;
  }

  payCardSuccess() {
    this._router.navigateByUrl("/PayCardSuccess");
  }

  onLetterChange(event) {
    this.selectedLetter = event.displayValue;
    console.log("requestLetterSelectedItem",  this.selectedLetter);
    this.RLServiceid = event.srvc;
    //this.CheckLettersEligibility();
  }



  async GetLettersList() {
    await this.commonP.presentLoading();
    this.cardService.GetLettersList({ Product: "C" }, this.auth.accessToken)
      .then((data: any) => {
        if (data?.response?.code == 1) {
          this.commonP.hideLoading();
          this.LettersList = data?.response.content.letterServicesList.map(x=> ({displayValue:x.desc_eng, srvc:x.srvc}));
          console.log("GetLettersList", data);
        } else {
          this.commonP.hideLoading();
          this.commonP.ParseErrorAlert("", "", this._router, data);
        }
      });
  }



  CheckLettersEligibility() {
    //
    let body = {
      internalId: this.selectedCardDetail?.internalId,
      Type: "1", // 1 for card, 2 for loan
      ServiceType: this.RLServiceid, // map srvc key, coming from GetLetterList api
      Status: "STATUSCHECK",
    };

    this.commonP.presentLoading();
    this.cardService.CheckLettersEligibility(body, this.auth.accessToken).then((data: any) => {
        if (data?.response?.code == 1) {
          //
          this.commonP.hideLoading();
          this.PaymentDetail = data?.response?.content;
          this.TotalAmount = Number(this.PaymentDetail?.charges) + Number(this.PaymentDetail?.vat);

          if ( data?.response?.content?.pendingRequestIndicator == "Y" && Number(data?.response?.content?.charges) == 0) {

            //  customer not eligibil
            let pendingRequest = true;
            this._router.navigate(["/CardReplacementSuccess"], { queryParams: { pendingRequest },});
          } 
          else if ( data?.response?.content?.pendingRequestIndicator == "N" && Number(data?.response?.content?.charges) == 0  ) {
            // Customer is Eligible No Payment Required

            this.LettersRequest();
          } else if ( data?.response?.content?.pendingRequestIndicator == "N" && Number(data?.response?.content?.charges) > 0 ) {
            // Customer is Eligible  Payment Required
            this.PaymentRequired = true;

            this.showModal("close", "");
            this.showModal(16, "");
          }
        } else {
          this.commonP.hideLoading();
          this.commonP.ParseErrorAlert("", "", this._router, data);
        }
      });
  }



  InititePaymentService() {
    let body = {
      InternalId: this.selectedCardDetail?.internalId,
      VendorId: 1, // 1 for benefit gateway, 2 for benefit pay
      AccountType: "C", // C for Card, L for Loan
      Amount: this.TotalAmount,
      ServiceType: "LL",
    };

    this.commonP.presentLoading();
    this.topupservice.InititePaymentService(this.auth.accessToken, body).then(async (data: any) => {
        if (data?.response.code == 1) {

          this.transactionRefId = data?.response?.content?.id;
          this.cookieService.set( "referenceId", this.transactionRefId, true);
          window.location.href = data?.response?.content?.url;
        } else {
          this.commonP.hideLoading();
          this.commonP.ParseErrorAlert("", "", this._router, data);
        }
      });
  }




  async LettersRequest() {
    //
    let data = {
      internalId: this.selectedCardDetail?.internalId,
      ServiceType: this.RLServiceid,
      Product: "C", // C for card, L for loan
    };
    await this.commonP.presentLoading();
    this.cardService.RequestingLetters(data, this.auth.accessToken).then(async (data: any) => {
        if (data?.response?.code == 1) {
          let letterRequest = true;
          let email = this.auth?.detailuser?.emailId;
          let Refid = data?.response?.content?.card?.referenceNumber;

          await this.commonP.hideLoading();
          this._router.navigate(["/CardReplacementSuccess"], { queryParams: { letterRequest, email, Refid },});
        } 
        else {
          await this.commonP.hideLoading();
          this.commonP.ParseErrorAlert("", "", this._router, data);
        }
      });
  }



  showModal(num, data) {
    if (data == "close") {
      this.modalObservable.next(data);
    }
    this.modalObservable.next(num);
  }



  CheckStatus() {
   //
    if (this.PaymentRequired) {

      // let key = this.cookieService.generateKey();
      // this.cookieService.set("selectedCardDetail", this.selectedCardDetail.toString(), false, key);

      // this.cookieService.set("internalid", this.selectedCardDetail?.internalId, false, key);
      // this.cookieService.set("ServiceType", this.RLServiceid, false, key);
      // this.cookieService.set("Product", "C", false, key);

      this.InititePaymentService();
    } 
   
  }
}
